import { LogsInitConfiguration } from '@datadog/browser-logs';

export function getDatadogConfig(env: string | undefined) {
    return {
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
        applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID!,
        site: process.env
            .NEXT_PUBLIC_DATADOG_SITE as LogsInitConfiguration['site'],
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        env: env || 'local',
        version: process.env.BUILD_ID,
        sessionSampleRate: 100,
    };
}
